import { useEffect, useRef, useState } from "react";
import DashbardHeader from "../AdmissionFom/DashbardHeader";
import Pakage from "../../../package.json"
import { useNavigate } from "react-router-dom";
import PrintComponent from "./PrintChalan";
import authService from "../../services/auth.service";
import ProfileEdit from "./Components/ProfileEdit";
import ChalanStatus from "./Components/ChalanStatus";
import MyApplicationsForm from "./Components/MyApplicationsForm";
import StudentDetails from "./Components/StudentDetails";
import Swal from "sweetalert2";
import MyApplicationsForm2 from "./Components/MyApplicationsForm2";
import { useDispatch, useSelector } from "react-redux";

const Dashboard = () => {
 
  const dispatch = useDispatch();
    
    useEffect(() => {
       authService.getUser(dispatch);
    }, []);

  const studentInformation = useSelector((state) => state.auth.studentData);

  // console.log("new Data", studentInformation);

  const [StudentChalanDetails, setStudentChalanDetails] = useState({
    profile_photo: studentInformation.profile_photo || null,
    category: studentInformation.category || "GENERAL",
    gender: studentInformation.gender || "",
    academic_level: studentInformation.academic_level || "",
    course_name: studentInformation.course_name || "",
    course_year: studentInformation.course_year || "",
    refrence_roll: studentInformation.refrence_roll || "0",
    admission_code: studentInformation.admission_code || "",
    same_state:studentInformation.same_state||0
  });

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const [completeProfile, setcompleteProfile] = useState(false);

  const [studentImagePreview, setStudentImagePreview] = useState(null);

  const handleInputChange = (e) => {
    setError([]);
    const { name, value, type, checked } = e.target;
    setStudentChalanDetails({
      ...StudentChalanDetails,
      [name]: type === "checkbox" ? checked : value,
    });
  };



  const handleStudentImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setStudentChalanDetails({
        ...StudentChalanDetails,
        profile_photo: file,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setStudentImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const [error, setError] = useState([]);
  // Log error state whenever it updates
  useEffect(() => {
    console.log("errors (from state):", error);
  }, [error]);

  const handleSubmit = async (e) => {
    const response = await authService.completeProfile(StudentChalanDetails);

    if (response.errors) {
      Swal.fire({
        title: "Complete Your Profile",
        icon: "error",
        showConfirmButton: true,
      });
      setError(response.errors); // Directly set errors array/object
      console.log("errors (from response):", response.errors);
    } else {
      Swal.fire({
        title: "Profile Complete successfully",
        icon: "success",
        showConfirmButton: true,
      });
      setcompleteProfile(!completeProfile);
    }
    await authService.getUser(dispatch);
  };




    const [visbile, setVisbile] = useState("payU");

  return (
    <>
      {" "}
      <div>
        <DashbardHeader    studentDetails={studentInformation} />
         <p style={{ color: 'black', paddingBlockStart: '10px', borderTop: '1px solid white', }}>V - {Pakage.version}  </p>

        {/* <button onClick={()=>console.log(studentInformation)}>hello</button> */}
        {/* <button onClick={()=>setVisbile("collage")}  className="secreate-button" >click</button> */}
        <div className="main-dashboard">
          <main className="main-dashboard-content">
            <div>
              <StudentDetails
                student={studentInformation}
                completeProfile={completeProfile}
                // handlePrint={handlePrint}
                setcompleteProfile={setcompleteProfile}
              />
            </div>

            {/* {visbile === "payU" && (
              <div>
                <MyApplicationsForm visbile={visbile} setVisbile={setVisbile}  student={studentInformation} />
              </div>
            )} */}

         
              <div>
                <MyApplicationsForm2 student={studentInformation} />
              </div>


            <div>
              <ChalanStatus
                student={studentInformation}
                formatDate={formatDate}
              />
            </div>
          </main>
        </div>

        {completeProfile && (
          <ProfileEdit
            error={error}
            setError={setError}
            setStudentChalanDetails={setStudentChalanDetails}
            studentDetails={studentInformation}
            StudentChalanDetails={StudentChalanDetails}
            handleStudentImageChange={handleStudentImageChange}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            studentImagePreview={studentImagePreview}
            completeProfile={completeProfile}
            setcompleteProfile={setcompleteProfile}
          />
        )}
      </div>
      {/* <PrintComponent
      /> */}
    </>
  );
};

export default Dashboard;
